// A control that acts like a button: it fires on a click of its icon, and only on
// a click. That takes a press and a release on the same icon, with the pointer
// staying put in between.
//
// Each of the three handlers covers one way that can fail:
//
// - Fabric runs a control's mouseUpHandler for whichever control is under the
//   pointer at release, wherever the press began. The transform it passes along is
//   the one the press set up, though, and its action only names this control if the
//   press landed on it. A press elsewhere has another action or no transform at all.
//   That includes the press that selects the element: the icons only appear with
//   the selection, so a press that lands where one then shows up is a plain 'drag'.
// - A pointer that wanders off and comes back ends up on the icon it started on, so
//   comparing the press with the release is not enough. Fabric calls actionHandler
//   for every move during the press, which is where the wandering gets noticed.
// - The release is still measured as well: it can land further away than the last
//   move reported.

// How far the pointer may drift, in screen pixels, and still count as holding
// still. A finger rolls as it lifts, so a tap needs more room than a mouse click.
export const CLICK_TOLERANCE_MOUSE = 4;
export const CLICK_TOLERANCE_TOUCH = 10;

function screenPoint(e) {
	const touch = e.changedTouches && e.changedTouches[0];
	const source = touch || e;
	return { x: source.clientX, y: source.clientY };
}

function noteTravel(e, transform) {
	const point = screenPoint(e);
	const distance = Math.hypot(point.x - transform.pressedAt.x, point.y - transform.pressedAt.y);
	const tolerance = e.changedTouches ? CLICK_TOLERANCE_TOUCH : CLICK_TOLERANCE_MOUSE;
	if (distance > tolerance) transform.pointerTravelled = true;
}

// Spread into the options of a fabric.Control. onClick gets the arguments of a
// mouseUpHandler: the release event and the transform.
export function clickControl(actionName, onClick) {
	return {
		actionName,
		mouseDownHandler(e, transform) {
			transform.pressedAt = screenPoint(e);
		},
		actionHandler(e, transform) {
			noteTravel(e, transform);
			// Nothing was transformed, so fabric has nothing to report or render.
			return false;
		},
		mouseUpHandler(e, transform) {
			if (!transform || transform.action !== actionName) return;
			noteTravel(e, transform);
			if (!transform.pointerTravelled) onClick(e, transform);
		},
	};
}
